module.exports = __webpack_public_path__ + "static/media/gmail-logo.dc6cee56.svg";